import React, { useState } from "react";
import axios from "axios";
import { useToast } from "../components/ToastContext";
import { PiEyeLight, PiEyeSlash } from "react-icons/pi";
import Utils from "../utils/utils";
import { useDispatch } from "react-redux";
import { fetchUserData } from "../actions/userActions";

const StudentProfileVerification = ({ user }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const dispatch = useDispatch();
  const [completeProfile, SetCompleteProfile] = useState(false);
  const [profileData, setProfileData] = useState({
    city: "",
    state: "",
    aadhaar: "aadhaar",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [progress, setProgress] = useState(0);
  const [completedFields, setCompletedFields] = useState({
    city: false,
    state: false,
    aadhaar: false,
    password: false,
  });

  const showToast = useToast();
  const handleBlur = (field) => {
    if (profileData[field]) {
      // Field has a value
      if (!completedFields[field]) {
        // Mark as complete if not previously marked
        setCompletedFields((prev) => ({ ...prev, [field]: true }));
        setProgress((prevProgress) => prevProgress + 25);
      }
    } else {
      if (completedFields[field]) {
        setCompletedFields((prev) => ({ ...prev, [field]: false }));
        setProgress((prevProgress) => prevProgress - 25);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prev) => ({ ...prev, [name]: value }));
  };

  const handleProfileVerification = async (e) => {
    e.preventDefault();
    profileData["updatedAt"] = new Date().toUTCString();

    try {
      const res = await axios.patch(
        `${SERVER_URL}/students/complete-profile/${user._id}`,
        profileData,
        {
          headers: {
            Authorization: `Bearer ${Utils.getToken()}`,
          },
        }
      );
      dispatch(fetchUserData());
      showToast("Your profile has been verified.", "success", true, 3000);
    } catch (error) {
      if (error.response.status === 403)
        showToast(
          error.response.data.message || "Unauthorized. Kindly login again .",
          "error",
          true,
          3000
        );
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mb-8 w-full">
      <div className="max-w-fit">
        <p className="text-2xl font-semibold text-gray-800 mb-4">
          Compelete Your Profile{" "}
        </p>
        <progress
          className="progress progress-error w-full"
          value="50"
          max="100"
        ></progress>
      </div>

      <form
        className="bg-white space-y-4 "
        onSubmit={handleProfileVerification}
      >
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
          <label className="form-control min-w-[50%]">
            <span className="label">City</span>
            <input
              type="text"
              name="city"
              onChange={handleInputChange}
              onBlur={() => handleBlur("city")}
              required
              placeholder="City"
              className="input input-bordered w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-pink-500"
            />
          </label>

          <label className="form-control min-w-[50%]">
            <span className="label">State</span>
            <input
              type="text"
              id="state"
              name="state"
              onChange={handleInputChange}
              onBlur={() => handleBlur("state")}
              required
              placeholder="State"
              className="input input-bordered  px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-pink-500"
            />
          </label>

          <label className="form-control min-w-[50%]">
            <span className="label">Aadhaar (12 digits)</span>
            <input
              type="text"
              id="aadhaar"
              name="aadhaar"
              onChange={handleInputChange}
              onBlur={() => handleBlur("aadhaar")}
              placeholder="Aadhaar"
              pattern="[0-9]{12}"
              required
              className="input input-bordered px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-pink-500"
            />
          </label>

          <label className="form-control min-w-[50%]">
            <span className="label">Password (Current Password)</span>
            <div className="relative w-full">
              <input
                name="password"
                minlength="8"
                onChange={handleInputChange}
                onBlur={() => handleBlur("password")}
                placeholder="********"
                required
                type={showPassword ? "text" : "password"}
                className="w-full input input-bordered px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-pink-500 "
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <PiEyeSlash /> : <PiEyeLight />}
              </span>
            </div>
          </label>
        </div>

        {/* <label className="form-control min-w-[50%] relative ">
              <span className="label">Password (Current Password)</span>
              <input
                type="password"
                name="password"
                minlength="8"
                onChange={handleInputChange}
                onBlur={() => handleBlur("password")}
                placeholder="Password"
                required
                className="input input-bordered px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-pink-500 "
              />
            </label> */}

        <div className="w-full flex gap-2 justify-between items-end">
          <progress
            className="progress progress-success w-1/2"
            value={progress}
            max="100"
          ></progress>

          <button
            type="submit"
            className="px-3 py-2 hover:tracking-[0.2rem] transition-all duration-200 border tracking-[.1em]
             border-pink-700 text-pink-700 font-semibold rounded-md hover:text-pink-800 hover:border-pink-800 hover:shadow-md "
          >
            VERIFY
          </button>
        </div>
      </form>
    </div>
  );
};

export default StudentProfileVerification;
